<script lang="ts" setup>
import { cn } from '@/lib/utils'
import { watch } from 'vue';
import { HTMLAttributes, inject } from 'vue'
const props = defineProps<{
    class?: HTMLAttributes['class']
}>()

const counter = defineModel<number>('counter', {
    default: 0,
})

const min = inject<number>('min', 0)
const max = inject<number>('max', 10000)

watch(() => counter.value, (newValue) => {
    if (newValue >= max) counter.value = max
    if (newValue < min) counter.value = min
})
</script>

<template>
    <input
        v-bind="$attrs"
        type="number"
        :min="min"
        :max="max"
        v-model="counter"
        :class="
            cn(
                'h-10 max-w-9 min-w-4 [appearance:textfield] text-center text-sm text-slate-800 focus-visible:outline-0 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none',
                props.class,
            )
        "
    />
</template>
